import * as React from "react";
import { FileAttachmentsTableMode } from "../../models";
import { ErrorBoundary } from "../../../errors/ErrorBoundary";
import { FileAttachment, File, WebPortalClient } from "webportalclient";
import { Bytes } from "@vitalograph/web-ui";
import { WebPortalLegacyClientInternal } from "../../../misc/api/WebPortalTokenClient";
import { FileDownload } from "../../../misc/FileDownload";

export interface FileAttachmentsTableProps {
    legacyClient: WebPortalLegacyClientInternal;
    mode: FileAttachmentsTableMode;
    fileAttachments: File[];
    onRemoveAttachment?: (fileIndex: number) => void;
}

declare const rootUrl: string;

const FileAttachmentsTable = (props: FileAttachmentsTableProps) => {
    const downloadAttachment = async (fileAttachment: File) => {
        if (fileAttachment) {
            const fileResult = await props.legacyClient.getFile(fileAttachment.id)
                .then(response => response.blob());

            FileDownload(fileResult, fileAttachment.fileName);
        }
    }

    const renderRowActionButton = (fileAttachment: File, fileIndex: number) => {
        return (
            <>
                {props.mode == FileAttachmentsTableMode.ListOnly ? (
                    <button
                        type="button"
                        className="btn btn-primary pull-right"
                        onClick={() => downloadAttachment(fileAttachment)}
                    >
                        <span className="fas fa-download" aria-hidden="true" />
                        &nbsp;View
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-danger pull-right"
                        onClick={() => props.onRemoveAttachment(fileIndex)}
                    >
                        <span className="fas fa-trash" aria-hidden="true" />
                        &nbsp;Remove
                    </button>
                )}
            </>
        );
    }

    const renderFileRow = (fileAttachment: File, index: number) => {
        return (
            <tr key={index}>
                <td>{fileAttachment.fileName}</td>
                <td><Bytes value={fileAttachment.fileSizeInBytes} /></td>
                <td>{renderRowActionButton(fileAttachment, index)}</td>
            </tr>
        );
    }

    return (
        <div className="col-lg-12">
            <ErrorBoundary>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>File Size</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>{props.fileAttachments.map((f, i) => renderFileRow(f, i))}</tbody>
                </table>
            </ErrorBoundary>
        </div>
    );
}

export default FileAttachmentsTable;
